import { useQuery } from "@tanstack/react-query";
import { departmentsServices } from "../services/departmentsServices";

export const useDepartaments = () => {
  return useQuery({
    queryKey: ["departments"],
    queryFn: async () => {
      // console.log("Hook useDepartments: Iniciando busca de departamentos");
      const departments = await departmentsServices.getDepartments();
      // console.log("Hook useDepartments: Departamentos obtidas:", departments);
      return departments;
    },
    retry: 3, // Tenta 3 vezes antes de falhar
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Backoff exponencial
    staleTime: 1000 * 60 * 5, // 5 minutos
    cacheTime: 1000 * 60 * 60, // 60 minutos
    onSuccess: (data) => {
      // console.log(
      //   "Hook useDepartments: Sucesso ao buscar departamentos:",
      //   data
      // );
    },
    onError: (error) => {
      console.error(
        "Hook useDepartments: Erro ao buscar departamentos:",
        error
      );
    },
  });
};
